import { App } from 'vue';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import routerGuards from './routerGuards';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/layout/AppLayout.vue'),
    children: [
      {
        path: '/homeAdmin',
        name: 'home',
        component: () => import('@/views/Home/HomeAdmin.vue'),
        meta: {
          title: '主页',
        },
      },
      {
        path: '/roleManager',
        name: 'roleManager',
        component: () => import('@/views/RoleManager/index.vue'),
        meta: {
          title: '角色管理',
          url:'/roleManager'
        },
      },
      {
        path: '/Edit',
        name: 'Edit',
        component: () => import('@/views/RoleManager/Edit.vue'),
        meta: {
          title: '编辑角色',
          url:'/roleManager'
        },
      },
      {
        path: '/nocManager',
        name: 'nocManager',
        component: () => import('@/views/NocManager/index.vue'),
        meta: {
          title: '职业分类管理',
          url: '/nocManager'
        },
      },
      {
        path: '/userManager',
        name: 'userManager',
        component: () => import('@/views/userManager/index.vue'),
        meta: {
          title: '用户管理',
          url: '/userManager'
        },
      },
      {
        path: '/commonManager', // 行政端口评价机构
        name: 'commonManager',
        component: () => import('@/views/commonManager/index.vue'),
        meta: {
          title: '评价机构管理',
          url: '/commonManager'
        },
      },
      {
        path: '/evaluateList', // 上级管理单位端口评价机构列表
        name: 'evaluateList',
        component: () => import('@/views/commonManager/evaluateList.vue'),
        meta: {
          title: '评价机构列表',
          url: '/evaluateList'
        },
      },
      {
        path: '/trainManager',
        name: 'trainManager',
        component: () => import('@/views/trainManager/index.vue'),
        meta: {
          title: '培训机构管理',
          url: '/trainManager'
        },
      },
      {
        path: '/trainList',
        name: 'trainList',
        component: () => import('@/views/trainManager/trainList.vue'),
        meta: {
          title: '培训机构列表',
          url: '/trainList'
        },
      },
      {
        path: '/evaluationUser',  // 
        name: 'evaluationUser',
        component: () => import('@/views/evaluationUser/index.vue'),
        meta: {
          title: '评价机构用户管理',
        },
      },
      {
        path: '/trainManagerUnit',
        name: 'trainManagerUnit',
        component: () => import('@/views/trainManagerUnit/index.vue'),
        meta: {
          title: '培训机构管理单位管理',
          url: '/trainManagerUnit'
        },
      },
      {
        path: '/certificateManager',
        name: 'certificateManager',
        component: () => import('@/views/certificateManager/index.vue'),
        meta: {
          title: '证书管理',
          url: '/certificateManager'
        },
      },
      {
        path: '/accountChange',
        name: 'accountChange',
        component: () => import('@/views/accountChange/index.vue'),
        meta: {
          title: '证书管理',
          url: '/accountChange'
        }
    },
    {
        path: '/count',
        name: 'count',
        component: () => import('@/views/count/getCertCount.vue'),
        meta: {
          title: '数据统计',
          url: '/count'
        },
      },
      {
        path: '/getCertCount',
        name: 'getCertCount',
        component: () => import('@/views/count/getCertCount.vue'),
        meta: {
          title: '获证人员统计',
          url: '/getCertCount'
        },
      },
      {
        path: '/accordingCount',
        name: 'accordingCount',
        component: () => import('@/views/count/accordingCount.vue'),
        meta: {
          title: '按评价机构统计',
          url: '/accordingCount'
        },
      },
      {
        path: '/superiorCount',
        name: 'superiorCount',
        component: () => import('@/views/count/superiorCount.vue'),
        meta: {
          title: '按上级管理部门统计',
          url: '/superiorCount'
        },
      },
      {
        path: '/trainingCount',
        name: 'trainingCount',
        component: () => import('@/views/count/trainingCount.vue'),
        meta: {
          title: '按培训机构统计',
          url: '/trainingCount'
        },
      },
      {
        path: '/certificateDeclareManager',
        name: 'certificateDeclareManager',
        component: () => import('@/views/certificateDeclareManager/index.vue'),
        meta: {
          title: '证书申报管理',
          url: '/certificateDeclareManager'
        },
      },
      {
        path: '/examRecordList',
        name: 'examRecordList',
        component: () => import('@/views/certificateDeclareManager/examRecordList.vue'),
        meta: {
          title: '证书申报管理',
          url: '/certificateDeclareManager'
        },
      },
      {
        path: '/studentInfo',
        name: 'studentInfo',
        component: () => import('@/components/student/studentInfo.vue'),
        meta: {
          title: '证书申报管理',
          url: '/certificateDeclareManager'
        },
      },
      {
        path: '/declareBatch/:param',
        name: 'declareBatch',
        component: () => import('@/views/declareBatch/index.vue'),
        meta: {
          title: '事业中心审核',
          url: '/declareBatch/center'
        },
      },
      {
        path: '/declareBatchButton/:param/:id/:type',
        name: 'declareBatchButton',
        component: () => import('@/views/declareBatch/batchButton.vue'),
        meta: {
            title: '事业中心审核按钮',
            url: '/declareBatch/center'
        },
      },

      {
        path: '/trainReview/:param',
        name: 'trainReview',
        component: () => import('@/views/trainReview/index.vue'),
        meta: {
          title: '培训机构变更审核',
          url: '/trainReview/center'
        },
      },

      {
        path: '/declareCertificateChange/:param',
        name: 'declareCertificateChange',
        component: () => import('@/views/certificateChange/index.vue'),
        meta: {
          title: '证书变更审核',
          url: '/declareCertificateChange/center'
        },
      },

      {
        path: '/departmentBatch/:param',
        name: 'departmentBatch',
        component: () => import('@/views/declareBatch/index.vue'),
        meta: {
          title: '专技司审核',
          url: '/departmentBatch/institution'
        },
      },
      {
        path: '/departmentBatchButton/:param/:id/:type',
        name: 'departmentBatchButton',
        component: () => import('@/views/declareBatch/batchButton.vue'),
        meta: {
            title: '专技司审核按钮',
            url: '/departmentBatch/institution'
        },
      },
      {
        path: '/departmentTrainReview/:param',
        name: 'departmentTrainReview',
        component: () => import('@/views/trainReview/index.vue'),
        meta: {
          title: '培训机构变更审核',
          url: '/departmentTrainReview/institution'
        },
      },
      {
        path: '/departmentCertificateChange/:param',
        name: 'departmentCertificateChange',
        component: () => import('@/views/certificateChange/index.vue'),
        meta: {
          title: '证书变更审核',
          url: '/departmentCertificateChange/institution'
        },
      },

      {
        path: '/declarationReview/:param',
        name: 'declarationReview',
        component: () => import('@/views/declareBatch/index.vue'),
        meta: {
            title: '批次申报审核',
            url: '/declarationReview/village'
        },
      },
      {
        path: '/declarationReviewButton/:param/:id/:type',
        name: 'declarationReviewButton',
        component: () => import('@/views/declareBatch/batchButton.vue'),
        meta: {
            title: '批次申报审核按钮',
            url: '/declarationReview/village'
        },
      },
      {
        path: '/certificateChangeUp/:param',
        name: 'certificateChangeUp',
        component: () => import('@/views/certificateChange/index.vue'),
        meta: {
          title: '证书变更审核',
          url: '/certificateChangeUp/village'
        },
      },
      {
        path: '/organizeManage/report',
        name: 'organizeManage-report',
        component: () => import('@/views/organizeManage/report.vue'),
        meta: {
          title: '培训机构申报',
          url: '/organizeManage/report'
        },
      },
      {
        path: '/middleOperate',
        name: 'middleOperate',
        component: () => import('@/views/organizeManage/middleOperate.vue'),
        meta: {
          title: '培训机构申报',
          url: '/organizeManage/report'
        },
      },
      {
        path: '/orgReporting',
        name: 'orgReporting',
        component: () => import('@/views/organizeManage/orgReporting.vue'),
        meta: {
          title: '培训机构上报管理',
          url: '/orgReporting'
        },
      },
      {
        path: '/orgReportAudit',
        name: 'orgReportAudit',
        component: () => import('@/views/organizeManage/orgReportAudit.vue'),
        meta: {
          title: '培训机构上报审核',
          url: '/orgReportAudit'
        },
      },
      {
        path: '/orgAuditView',
        name: 'orgAuditView',
        component: () => import('@/views/organizeManage/orgAuditView.vue'),
        meta: {
          title: '培训机构上报审核-查看',
          url: '/orgAuditView'
        },
      },
      {
        path: '/orgAuditExitView',
        name: 'orgAuditExitView',
        component: () => import('@/views/organizeManage/orgAuditExitView.vue'),
        meta: {
          title: '培训机构上报审核-退出查看',
          url: '/orgAuditExitView'
        },
      },
      {
        path: '/orgAuditEditView',
        name: 'orgAuditEditView',
        component: () => import('@/views/organizeManage/orgAuditEditView.vue'),
        meta: {
          title: '培训机构上报审核-修改查看',
          url: '/orgAuditEditView'
        },
      },
      {
        path: '/orgReportingAdd',
        name: 'orgReportingAdd',
        component: () => import('@/views/organizeManage/orgReportingAdd.vue'),
        meta: {
          title: '培训机构上报管理-新增',
          url: '/orgReportingAdd'
        },
      },
      {
        path: '/orgReportingContinue',
        name: 'orgReportingContinue',
        component: () => import('@/views/organizeManage/orgReportingContinue.vue'),
        meta: {
          title: '培训机构上报管理-延续',
          url: '/orgReportingContinue'
        },
      },
      {
        path: '/orgExit',
        name: 'orgExit',
        component: () => import('@/views/organizeManage/orgReportingExit.vue'),
        meta: {
          title: '培训机构上报管理-退出',
          url: '/orgExit'
        },
      },
      {
        path: '/orgReportingEdit',
        name: 'orgReportingEdit',
        component: () => import('@/views/organizeManage/orgReportingEdit.vue'),
        meta: {
          title: '培训机构上报管理-修改',
          url: '/orgReportingEdit'
        },
      },
      {
        path: '/organizeEvaluate/reportEvaluate',
        name: 'organizeManage-reportEvaluate',
        component: () => import('@/views/organizeEvaluate/reportEvaluate.vue'),
        meta: {
          title: '评价机构申报',
          url: '/organizeEvaluate/reportEvaluate'
        },
      },
      {
        path: '/middleOperateEva',
        name: 'middleOperateEva',
        component: () => import('@/views/organizeEvaluate/middleOperate.vue'),
        meta: {
          title: '评价机构申报',
          url: '/organizeEvaluate/reportEvaluate'
        },
      },
      {
        path: '/viewTrainInfo',
        name: 'viewTrainInfo',
        component: () => import('@/views/organizeManage/components/viewTrainInfo.vue'),
        meta: {
          title: '培训机构申报',
          url: '/organizeManage/examineLast'
        },
      },
      {
        path: '/organizeManage/examineFirst',
        name: 'organizeManage-examineFirst',
        component: () => import('@/views/organizeManage/examineFirst.vue'),
        meta: {
          title: '培训机构申报初审',
          url: '/organizeManage/examineFirst'
        },
      },
      {
        path: '/firstExamineTrain', // 初审点击去初审跳转的页面
        name: 'firstExamineTrain',
        component: () => import('@/views/organizeManage/components/firstExamine.vue'),
        meta: {
          title: '培训机构申报初审',
          url: '/organizeManage/examineFirst'
        },
      },
      {
        path: '/organizeManage/examineLast',
        name: 'organizeManage-examineLast',
        component: () => import('@/views/organizeManage/examineLast.vue'),
        meta: {
          title: '培训机构申报终审',
          url: '/organizeManage/examineLast'
        },
      },
      {
        path: '/singleEvaCheck',
        name: 'singleEvaCheck',
        component: () => import('@/views/organizeManage/singleCheck.vue'),
        meta: {
          title: '培训机构申报终审',
          url: '/organizeManage/examineLast'
        },
      },
      {
        path: '/evaExamineFirst',
        name: 'evaExamineFirst',
        component: () => import('@/views/evaExamine/examineFirst.vue'),
        meta: {
          title: '评价机构申报初审',
          url: '/evaExamineFirst'
        },
      },
      {
        path: '/firstExamine', // 初审点击去初审跳转的页面
        name: 'firstExamine',
        component: () => import('@/views/evaExamine/components/firstExamine.vue'),
        meta: {
          title: '评价机构申报初审',
          url: '/evaExamineFirst'
        },
      },
      {
        path: '/evaExamineLast',
        name: 'evaExamineLast',
        component: () => import('@/views/evaExamine/examineLast.vue'),
        meta: {
          title: '评价机构申报终审',
          url: '/evaExamineLast'
        },
      },
      {
        path: '/evaReportCheck',
        name: 'evaReportCheck',
        component: () => import('@/views/evaExamine/components/reportCheck.vue'),
        meta: {
          title: '评价机构申报终审',
          url: '/evaExamineLast'
        },
      },
      {
        path: '/viewEvaluateInfo',
        name: 'viewEvaluateInfo',
        component: () => import('@/views/evaExamine/components/viewEvaluateInfo.vue'),
        meta: {
          title: '评价机构申报终审',
          url: '/evaExamineLast'
        },
      },
      {
        path: '/excle',
        name: 'excle',
        component: () => import('@/components/Excle/index.vue'),
        meta: {
          title: '数字技术工程师培育项目培训机构推荐表',
          url: '/organizeManage/report'
        },
      },
      {
        path: '/evaluateExcle',
        name: 'evaluateExcle',
        component: () => import('@/components/Excle/evaluateExcle.vue'),
        meta: {
          title: '数字技术工程师培育项目评价机构推荐表',
          url: '/organizeEvaluate/reportEvaluate'
        },
      },
      {
        path: '/recomExpert',
        name: 'recomExpert',
        component: () => import('@/views/recomExpert/index.vue'),
        meta: {
          title: '推荐专家管理',
          url: '/recomExpert'
        },
      },
      {
        path: '/reportSet',
        name: 'reportSet',
        component: () => import('@/views/reportSet/index.vue'),
        meta: {
          title: '机构申报配置',
          url: '/reportSet'
        },
      },
      {
        path: '/addYearRecom',
        name: 'addYearRecom',
        component: () => import('@/views/reportSet/addYearRecom.vue'),
        meta: {
          title: '机构申报配置',
          url: '/reportSet'
        },
      },
      {
        path: '/addUnitExpert',
        name: 'addUnitExpert',
        component: () => import('@/views/reportSet/addUnitExpert.vue'),
        meta: {
          title: '机构申报配置',
          url: '/reportSet'
        },
      },
      {
        path: '/organizeManage/trainManage',
        name: 'organizeManage-trainManage',
        component: () => import('@/views/trainOrganizeManger/index.vue'),
        meta: {
          title: '培训机构管理',
          url: '/organizeManage/trainManage'
        },
      },
      {
        path: '/trainOrgListEdit',
        name: 'trainOrgListEdit',
        component: () => import('@/views/organizeManage/trainOrgListEdit.vue'),
        meta: {
          title: '培训机构管理',
          url: '/trainOrgListEdit'
        },
      },
      {
        path: '/trainReportRecom',
        name: 'trainReportRecom',
        component: () => import('@/views/trainReportRecom/index.vue'),
        meta: {
          title: '培训机构评审',
          url: '/trainReportRecom'
        },
      },
      {
        path: '/reviewProfession',
        name: 'reviewProfession',
        component: () => import('@/views/trainReportRecom/reviewProfession.vue'),
        meta: {
          title: '培训机构评审',
          url: '/trainReportRecom'
        },
      },
      {
        path: '/evaReportRecom',
        name: 'evaReportRecom',
        component: () => import('@/views/evaReportRecom/index.vue'),
        meta: {
          title: '评价机构评审',
          url: '/evaReportRecom'
        },
      },
      {
        path: '/reviewProfessionEva',
        name: 'reviewProfessionEva',
        component: () => import('@/views/evaReportRecom/reviewProfession.vue'),
        meta: {
          title: '评价机构评审',
          url: '/evaReportRecom'
        },
      },
      {
        path: '/evaluateManager',
        name: 'evaluateManager',
        component: () => import('@/views/evaluateManager/index.vue'),
        meta: {
          title: '评价机构管理',
          url: '/evaluateManager'
        },
      },
      {
        path: '/trainReportResult',
        name: 'trainReportResult',
        component: () => import('@/views/trainReportResult/index.vue'),
        meta: {
          title: '培训机构申报结果',
          url: '/trainReportResult'
        },
      },
      {
        path: '/trainViewResult',
        name: 'trainViewResult',
        component: () => import('@/views/trainReportResult/trainViewResult.vue'),
        meta: {
          title: '培训机构申报结果',
          url: '/trainViewResult'
        },
      },
    ]
},
  {
    path: '/login',  // 行政管理中心登录
    name: 'Login',
    component: () => import('@/views/Login/index.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/evaluateLogin', // 评价机构登录
    name: 'evaluateLogin',
    component: () => import('@/views/Login/evaluateLogin.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/managerLogin', // 上级管理单位登录
    name: 'managerLogin',
    component: () => import('@/views/Login/managerLogin.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/expertLogin', // 上级管理单位登录
    name: 'expertLogin',
    component: () => import('@/views/Login/expertLogin.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/FoundPwd',
    name: 'FoundPwd',
    component: () => import('@/views/FoundPwd/index.vue'),
    meta: {
      title: '登录/找回密码',
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Login/register.vue'),
    meta: {
      title: '注册',
    },
  },
  {
    path: '/certInquiry',  // 证书查询登录
    name: 'certInquiry',
    component: () => import('@/views/certificateInquiry/index.vue'),
    meta: {
      title: '证书查询',
    },
  },
  {
    path: '/rolechose',  // 
    name: 'rolechose',
    component: () => import('@/views/choseRole.vue'),
    meta: {
      title: '选择登录角色',
    },
  },
  
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export function setupRouter(app: App) {
  app.use(router);
  routerGuards(router);
}

export default router;
